import { AnimatedSprite, Texture, Container, Sprite, Rectangle } from "pixi.js";

type FireParams = {
  fire: Texture[];
  base: Texture;
};

type Fire = {
  container: Container;
  getHitArea: () => Rectangle;
  resize: () => void;
};

const SCALE = 1.5;

export function createFire({ fire, base }: FireParams): Fire {
  const fireSprite = new AnimatedSprite(fire);
  fireSprite.animationSpeed = 0.0835;
  fireSprite.play();

  const baseSprite = new Sprite(base);
  baseSprite.position.x = 5;
  baseSprite.position.y = 60;

  const container = new Container();
  container.scale.x = SCALE;
  container.scale.y = SCALE;

  container.addChild(baseSprite);
  container.addChild(fireSprite);

  const getHitArea = () => {
    return fireSprite.getFastGlobalBounds().rectangle;
  };

  const resize = () => {
    const dw = document.documentElement.clientWidth;
    const dh = document.documentElement.clientHeight;

    container.position.x = dw / 2 - 32 * SCALE;
    container.position.y = dh / 2 - 32 * SCALE;
  };

  resize();

  return {
    container,
    getHitArea,
    resize,
  };
}
